import { RootState } from '../reducers';
import * as authAsTypes from './types';

export const getSelectedteacherId = (state: RootState): authAsTypes.TeacherModal => state.AuthAs.teacherModal;
export const getAuthAs = (state: RootState): authAsTypes.AuthAsState => state.AuthAs;
export const getParentData = (state: RootState): AppConfig.User | null => state.Auth.parent;